import { Component, OnInit } from '@angular/core';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { UserNotificationDto } from 'src/app/model/core/UserNotificationDto';
import { RolesEnum } from 'src/app/service/enums/role.enum';
import { NotificationService } from 'src/app/service/notification.service';

import { BaseComponent } from '../components/base.component';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  providers: [NgbDropdownConfig]
})
export class NavbarComponent extends BaseComponent implements OnInit {
  public iconOnlyToggled = false;
  public sidebarToggled = false;
  notificationsCount: number = 0;
  myNotifications: UserNotificationDto[];
  showHasNotification: boolean = false;
  constructor(config: NgbDropdownConfig,
    private notificationService: NotificationService) {
    super();
    config.placement = 'bottom-right';
    //translate.setDefaultLang('en');
  }

  ngOnInit() {
    if (this.userprofile.isLoggedIn === true && this.userprofile.id != null && this.userprofile.id != 0 && !this.userProfileService.isOnlyRoleExists(RolesEnum.Customer)) {
      this.getMyNotificationsCount()
    }
  }

  // toggle sidebar in small devices
  toggleOffcanvas() {
    document.querySelector('.sidebar-offcanvas').classList.toggle('active');
  }

  // toggle sidebar
  toggleSidebar() {
    let body = document.querySelector('body');
    if ((!body.classList.contains('sidebar-toggle-display')) && (!body.classList.contains('sidebar-absolute'))) {
      this.iconOnlyToggled = !this.iconOnlyToggled;
      if (this.iconOnlyToggled) {
        body.classList.add('sidebar-icon-only');
      } else {
        body.classList.remove('sidebar-icon-only');
      }
    } else {
      this.sidebarToggled = !this.sidebarToggled;
      if (this.sidebarToggled) {
        body.classList.add('sidebar-hidden');
      } else {
        body.classList.remove('sidebar-hidden');
      }
    }
  }

  // toggle right sidebar
  toggleRightSidebar() {
    document.querySelector('#right-sidebar').classList.toggle('open');
  }

  logout() {
    this.userProfileService.clearProfile();
    this.router.navigate(["/account/login"]);
  }

  changeLanguage() {
    if (this.lang === 'ar') {
      localStorage.setItem("lang", "en");
    } else {
      localStorage.setItem("lang", "ar");
    }
    location.reload();
  }


  getMyNotificationsCount() {
    this.notificationService.GetMyNotificationCount().subscribe(
      res => {
        if (res.successed) {
          this.notificationsCount = res.data;
          if (this.notificationsCount > 0) {
            this.showHasNotification = true;
          }
        }
        else {
          this.toastrAlertService.errorToastr(res.errorMessage);
        }
      },
      error => {
        if (typeof error.error !== "undefined") {
          this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate(error.error));
        }
      }
    )
  }

  getTopMyNotifications() {
    this.showHasNotification = false;

    this.notificationService.GetTopMyNotifications().subscribe(
      res => {
        if (res.successed) {
          this.myNotifications = res.data;
          this.getMyNotificationsCount();
        }
        else {
          this.toastrAlertService.errorToastr(res.errorMessage);
        }
      },
      error => {
        if (typeof error.error !== "undefined") {
          this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate(error.error));
        }
      }
    )
  }

  goToNotifications() {
    this.router.navigate(["/user/notifications"])
  }

  goToRoute(notification) {
    this.router.navigate([notification.localClickAction])
  }

}
